
<v-expand-transition>
    <div class="inb-entry-buttons">
        <div>
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        depressed
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        class="inb-entry-button"
                        @click="onEditMessage"
                    >
                        <v-icon small color="white">fas fa-pen</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t("inb.edit.menu.edit") }}</span>
            </v-tooltip>
        </div>

        <div>
            <v-tooltip left v-if="!message.incidentId && message.incidentType && message.sites.length > 0">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        depressed
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        class="inb-entry-button"
                        @click="onCreateIncident"
                    >
                        <v-icon small color="white">fas fa-plus</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t("inb.edit.menu.create") }}</span>
            </v-tooltip>

            <v-tooltip left v-if="message.incidentId !== null">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        depressed
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        class="inb-entry-button"
                        @click="onGotoIncident"
                    >
                        <v-icon small color="white">fas fa-arrow-left</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t("inb.edit.menu.goto") }}</span>
            </v-tooltip>
        </div>
    </div>

</v-expand-transition>
